import { CurrentSubscriptionVm } from './../classes/currentSubscription';
import { AppResponse } from 'modules/core/interfaces/appResponse';
import AuthorizedApiClient from 'modules/auth/models/authorizedApiClient';
import { AxiosResponse } from 'axios';
import store from '@/store/index';
import { PlanVm } from '../classes/plan';

export class PlanApi {
  public async getCurrentSubscription(): Promise<CurrentSubscriptionVm | undefined> {
    const response: AxiosResponse<
      AppResponse<CurrentSubscriptionVm>
    > = await AuthorizedApiClient.get('/account/GetSubscription');

    const appResponse: AppResponse<CurrentSubscriptionVm> = response.data;
    if (appResponse.IsSuccess) {
      return appResponse.Result;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

  public async getSubscriptions(durationType: string): Promise<PlanVm[]> {
    const response: AxiosResponse<
      AppResponse<PlanVm[]>
    > = await AuthorizedApiClient.get('/subscription/GetAvailableSubscriptions?durationType=' + durationType);

    const appResponse: AppResponse<PlanVm[]> = response.data;
    if (appResponse.IsSuccess) {
      return appResponse.Result;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

  public async cancelSubscription(): Promise<string> {
    const response: AxiosResponse<
      AppResponse<string>
    > = await AuthorizedApiClient.post('/payment/CancelSubscription');

    const appResponse: AppResponse<string> = response.data;
    if (appResponse.IsSuccess) {
      return appResponse.Result;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }
}
